import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { volumes } from '../data/volumes';
export function VolumesSection() {
  return <section className="py-24 px-4 bg-slate-50" data-id="element-318" data-mp="coiu4r4d9dov">
      <div className="max-w-6xl mx-auto" data-id="element-319" data-mp="cn7soxye8i0x">
        <div className="text-center mb-16" data-id="element-320" data-mp="cm51eox5sdkh">
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-4 text-blue-950" data-id="element-321" data-mp="7qhc89iofkez">
            THE 6-IN-1 FLIGHT INSTRUCTOR <span className="text-orange-500" data-id="element-322" data-mp="3g5r9n4bmg1gf">READY</span> SYSTEM
          </h2>
          <p className="text-xl text-slate-700" data-id="element-323" data-mp="3c4nvqnd4wfhu">
            <span className="text-orange-500 font-semibold" data-id="element-324" data-mp="3c1t9cqak8kls">150 Ready-to-Teach Flight Lessons</span>{' '}
            · Beginner to Checkride-Ready · 100% Visual Teaching Tools · Nothing to Build From
            Scratch
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-325" data-mp="2xdop3hvv010w">
          {volumes.map((volume, index) => <motion.article key={volume.number} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className={`bg-white rounded-2xl border ${volume.popular ? 'border-2 border-orange-500 shadow-lg shadow-blue-950/10' : 'border-slate-200 shadow-sm shadow-blue-950/5'} p-8 relative overflow-hidden flex flex-col h-full`} data-id="element-326" data-mp="2selvqup8rj8r" data-mpi={index}>
              {volume.popular && <div className="absolute top-6 right-[-38px] bg-orange-500 text-white font-bold text-xs py-1 px-10 rotate-45 shadow" data-id="element-327" data-mp="1vhtsrin62syn">
                  MOST POPULAR
                </div>}

              <div className="flex items-center gap-4 mb-6 pr-10" data-id="element-328" data-mp="24eb7evuqp8z5">
                <span className="w-12 h-12 rounded-xl bg-blue-600 text-white font-serif font-extrabold text-2xl flex items-center justify-center shrink-0" aria-hidden="true" data-id="element-329" data-mp="3bt7i0l3trmzg">
                  {index + 1}
                </span>
                <div data-id="element-330" data-mp="1bsj4ismrldh0">
                  <div className="text-blue-600 font-bold text-sm uppercase tracking-wider" data-id="element-331" data-mp="1br7y0l1xprm7">
                    {volume.number}
                  </div>
                  <h3 className="text-2xl font-serif font-bold leading-tight mt-1 text-blue-950" data-id="element-332" data-mp="1ksnzg3arujea">
                    {volume.title}
                  </h3>
                </div>
              </div>

              <p className="text-blue-950 font-semibold mb-6 border-l-4 border-orange-500 pl-4" data-id="element-333" data-mp="t1i6c6tgxlyi">
                {volume.subtitle}
              </p>

              {(volume.intro.length > 0 || volume.questions || volume.highlight) && <div className="mb-6 space-y-2" data-id="element-334" data-mp="1214x7yokn9db">
                  {volume.intro.map(paragraph => <p key={paragraph} className="text-slate-800 text-sm leading-relaxed" data-id="element-335" data-mp="eardcvg54gtt">
                      {paragraph}
                    </p>)}
                  {volume.questions && <ul className="grid sm:grid-cols-2 gap-2 pt-1" data-id="element-336" data-mp="2kzb7bz2mjlpk">
                      {volume.questions.map(question => <li key={question} className="text-blue-600 font-semibold text-sm bg-blue-50 border border-blue-100 rounded-lg px-3 py-2" data-id="element-337" data-mp="2bzwl5bthpxav">
                          {question}
                        </li>)}
                    </ul>}
                  {volume.highlight && <p className="text-white font-bold text-base bg-blue-950 border-l-4 border-orange-500 rounded-lg px-4 py-3" data-id="element-338" data-mp="2uqe8f0vk00ou">
                      {volume.highlight}
                    </p>}
                  {volume.afterHighlight && <p className="text-slate-800 text-sm leading-relaxed" data-id="element-339" data-mp="1j9o0ndbhf0t4">{volume.afterHighlight}</p>}
                </div>}

              <div data-id="element-340" data-mp="23kigrxgxg925">
                <div data-id="element-341" data-mp="23l0gj42st5et">
                  <p className="text-blue-950 font-semibold text-sm mb-3" data-id="element-342" data-mp="23l9xy39s248w">{volume.bulletsIntro}</p>
                  <ul className={`mb-6 ${volume.bullets.length > 10 ? 'grid sm:grid-cols-2 gap-x-4 gap-y-3 content-start' : 'space-y-3'}`} data-id="element-343" data-mp="1yrz0gsquuztn">
                    {volume.bullets.map(bullet => <li key={bullet} className="flex items-start gap-3" data-id="element-344" data-mp="2ih9gy8yfdost">
                        <CheckCircle2 size={18} className="text-blue-600 shrink-0 mt-0.5" data-id="element-345" data-mp="2ii13yvdyie7h" />
                        <span className="text-slate-800 text-sm" data-id="element-346" data-mp="2dgbnv1bvnacj">{bullet}</span>
                      </li>)}
                  </ul>
                </div>

                {volume.secondaryBullets && <div data-id="element-347" data-mp="120n0w9ymibbq">
                    <p className="text-blue-950 font-semibold text-sm mb-3" data-id="element-348" data-mp="x46fvomq0d2v">
                      {volume.secondaryBulletsIntro}
                    </p>
                    <ul className="mb-6 grid sm:grid-cols-2 gap-x-4 gap-y-3 content-start" data-id="element-349" data-mp="n1sym3oglxfe">
                      {volume.secondaryBullets.map(bullet => <li key={bullet} className="flex items-start gap-3" data-id="element-350" data-mp="wxvx8zk3rdxl">
                          <CheckCircle2 size={18} className="text-blue-600 shrink-0 mt-0.5" data-id="element-351" data-mp="11om4kic39qux" />
                          <span className="text-slate-800 text-sm" data-id="element-352" data-mp="15qhci5oiz2ho">{bullet}</span>
                        </li>)}
                    </ul>
                  </div>}
              </div>

              {volume.sequence && <div className="mb-6" data-id="element-353" data-mp="1fp6lta2cvemb">
                  <p className="text-blue-950 font-semibold text-sm mb-2" data-id="element-354" data-mp="1knq85bkv2sf7">{volume.sequenceIntro}</p>
                  <p className="text-blue-600 font-bold text-sm bg-blue-50 border border-blue-100 rounded-lg px-3 py-2" data-id="element-355" data-mp="3hg09ylqet45x">
                    {volume.sequence}
                  </p>
                </div>}

              <div className="bg-amber-50 border border-amber-200/70 border-l-4 border-l-orange-500 rounded-xl p-4 mt-auto" data-id="element-356" data-mp="3edvqsdt62zzj">
                <span className="text-blue-950 font-bold block mb-1" data-id="element-357" data-mp="39gm3b3pc8yec">RESULT</span>
                {volume.resultLead && <p className="text-slate-800 text-sm" data-id="element-358" data-mp="3odwa3zr1dg3q">
                    {volume.resultLead}{' '}
                    <span className="font-semibold text-blue-950" data-id="element-359" data-mp="3jfl2lvo7rhoo">{volume.resultQuote}</span>
                  </p>}
                <p className="text-slate-800 text-sm" data-id="element-360" data-mp="3seg815jfonqx">{volume.result}</p>
                {volume.resultEmphasis && <p className="mt-2 text-xl font-serif font-extrabold text-orange-500" data-id="element-361" data-mp="axyfg1j9rlzm">
                    {volume.resultEmphasis}
                  </p>}
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}